'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStubbedThreadHistory = undefined;

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getStubbedThreadHistory = exports.getStubbedThreadHistory = (0, _get2.default)('stubbedThreadHistory');